<script lang="ts" setup>
  import { useFetchInvestorEvents } from '@/composables/useFetchInvestorEvents'

  const { fetchInvestorEvents } = useFetchInvestorEvents()

  const { locale } = useI18n()
  const investorEvents = ref()

  const props = defineProps<{
    blok: {
      title: string
      buttonTitle: string
      href: Object
      target: string
      eventCount: number
    }
  }>()

  onMounted(() => {
    getEvents()
  })

  const getEvents = async () => {
    investorEvents.value = await fetchInvestorEvents(locale.value, undefined, undefined, true)
  }
</script>

<template>
  <div
    v-if="investorEvents?.events?.futureEvents"
    class="upcoming-events-banner-wrapper"
  >
    <div class="block-title">
      <h2 class="text-bt-blue-dark text-h2">{{ props.blok.title }}</h2>
    </div>
    <div class="mb-6 lg:mb-10">
      <EventCards
        :blok="investorEvents.events.futureEvents"
        show-slider
      />
    </div>
  </div>
</template>
